/**
 * 前端多语言解决方案
 */
import url from 'c-url';
import LangPack from './pack';

let lang = url.query('lang');
let tws = ['zh-SG', 'zh-MO', 'zh-TW', 'zh-HK'];
let ars = [
    'ar-AE',
    'ar-BH',
    'ar-DZ',
    'ar-EG',
    'ar-IQ',
    'ar-JO',
    'ar-KW',
    'ar-LB',
    'ar-LY',
    'ar-MA',
    'ar-OM',
    'ar-QA',
    'ar-SA',
    'ar-SY',
    'ar-TN',
    'ar-YE'
];
if (!lang) {
    let systemLanguage = navigator.language || navigator.browserLanguage;
    let _systemLanguage = systemLanguage.toLowerCase();

    switch (_systemLanguage) {
        case 'ar':
            systemLanguage = 'ar-EG';
            break;
        case 'vi':
            systemLanguage = 'vi-VN';
            break;
        case 'en':
            systemLanguage = 'en-US';
            break;
        case 'ja':
            systemLanguage = 'ja-JP';
            break;
        case 'zh':
            systemLanguage = 'zh-CN';
            break;
        default:
            break;
    }

    let arr = systemLanguage.split('-');

    if (arr.length > 1) {
        systemLanguage = arr[0] + '-' + arr[1].toUpperCase();
    } else {
        systemLanguage = 'en-US';
    }

    if (systemLanguage == 'zh-CN' || systemLanguage == 'ja-JP' || systemLanguage == 'vi-VN' || systemLanguage == 'id-ID') {
        lang = systemLanguage;
    } else if (tws.indexOf(systemLanguage) >= 0) {
        lang = 'zh-TW';
    } else if (ars.indexOf(systemLanguage) >= 0) {
        lang = 'ar-EG';
    } else {
        lang = 'en-US';
    }
}


let _lang = {

    type: lang,

    init: function(langvalue) {
        let langType = langvalue.replace('-', '').toLowerCase();
        
        $('html').attr('lang', langvalue);
        $('body').attr('data-lang', langType);
        
        this.langType = langType;
    },

    template: function(tplStr, data, insertEM) {
        let langPack = LangPack[this.langType] || LangPack['enus'];
        let tpl = langPack[tplStr] || tplStr;

        if (tpl.indexOf('@@@@') > 0) {
            let strArr = [];

            strArr.push('<ul>');
            tpl.split('@@@@').forEach(function(item, index) {
                item && strArr.push('<li>' + item + '</li>');
            });
            strArr.push('</ul>');
            tpl = strArr.join('');
        }
        if (insertEM) {
            tpl = tpl.replace(/\{([\s\S]+?)\}/ig, function($0, $1) {
                if (insertEM) {
                    return '<em class="' + $1 + '">' + data[$1] + '</em>';
                } else {
                    return data[$1];
                }
            });
        }
        return tpl
    }
};

_lang.init(lang);

module.exports = _lang;


// WEBPACK FOOTER //
// ./js/lang/index.js